import { http } from '@/api/http';
import { ApiResponseBody } from '@/api/types';
import { getReleaseNotesApiUrl } from './release-notes.paths';
import {
  ReleaseNote,
  ReleaseNotesResponse,
  ReleaseNotesQueryParams,
  CreateReleaseNotePayload,
  UpdateReleaseNotePayload,
} from './release-notes.types';

const getReleaseNotes = async (params?: ReleaseNotesQueryParams): Promise<ReleaseNotesResponse> => {
  const res = await http.get<ApiResponseBody<ReleaseNotesResponse>>(getReleaseNotesApiUrl.list(), { params });
  return res.data.data;
};

const getReleaseNoteById = async (releaseNoteId: string): Promise<ReleaseNote> => {
  const res = await http.get<ApiResponseBody<ReleaseNote>>(getReleaseNotesApiUrl.byId(releaseNoteId));
  return res.data.data;
};

const createReleaseNote = async (body: CreateReleaseNotePayload): Promise<ReleaseNote> => {
  const res = await http.post<ApiResponseBody<ReleaseNote>>(getReleaseNotesApiUrl.list(), body);
  return res.data.data;
};

const updateReleaseNote = async (releaseNoteId: string, body: UpdateReleaseNotePayload): Promise<ReleaseNote> => {
  const res = await http.put<ApiResponseBody<ReleaseNote>>(getReleaseNotesApiUrl.byId(releaseNoteId), body);
  return res.data.data;
};

const deleteReleaseNote = async (releaseNoteId: string): Promise<void> => {
  await http.delete(getReleaseNotesApiUrl.byId(releaseNoteId));
};

export const releaseNotesApiFetcher = {
  getReleaseNotes,
  getReleaseNoteById,
  createReleaseNote,
  updateReleaseNote,
  deleteReleaseNote,
};
